export default __webpack_public_path__ + "static/media/5.8ed297c9.jpeg";